/**
 * Currency Enumeration
 */
export interface ITranslationItem {
  code: string;
  id: string;
}

export const BANK_TRANSLATION_CODES: ITranslationItem[] = [
  {
    code: "0",
    id: "selectYourBank",
  },
];

export const CONFRONTA_TRANSLATION_CODES: ITranslationItem[] = [
  {
    code: "CFT001",
    id: "selectYourDepartment",
  },
  {
    code: "CFT002",
    id: "selectYourCity",
  },
];



// WEBPACK FOOTER //
// ./src/shared/BankCatalogEnum.ts